const EIGHT_AM_HOURS = 8;

export function getDefaultEstimatedStartDate(now = Date.now()) {
  const date = new Date(now);
  date.setHours(EIGHT_AM_HOURS, 0, 0, 0);
  return date.getTime();
}

export function getDefaultEstimatedDuration() {
  return 1;
}
